import { StyledComponent } from '@emotion/styled';
import { styled } from '@mui/material/styles';
import MuiToggleButton, { ToggleButtonProps, toggleButtonClasses } from '@mui/material/ToggleButton';

export const ToggleButton: StyledComponent<ToggleButtonProps> = styled(MuiToggleButton)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  color: 'black',
  [`&.${toggleButtonClasses.selected}`]: {
    borderColor: theme.palette.primary.main,
  },
}));
